import { useState } from "react";
import { useLeads, type LeadRow } from "@/modules/leads/api";
import { LeadsTable, LeadDrawer } from "@/modules/leads/LeadsPage";
import { EmptyState } from "@/components/shared/EmptyState";

export function ClientLeadsTab({ clientId }: { clientId: string }) {
  const { data: leads } = useLeads({ clientId });
  const [open, setOpen] = useState<LeadRow | null>(null);
  return (
    <div>
      {leads && leads.length === 0 ? <EmptyState title="Aucun lead" description="Les leads attribués et livrés à ce client apparaîtront ici." /> : leads && <LeadsTable leads={leads} onOpen={setOpen} />}
      <LeadDrawer lead={open} onClose={() => setOpen(null)} />
    </div>
  );
}
